import moment from "moment"

import { ITableColumn } from "components/UI/organisms/Table/TableTypes"
import { formatPhoneNumber } from "utils/formatPhoneNumber"

import { Flex, Text, } from "@chakra-ui/react"
import Icon from "components/UI/atoms/Icon"
import { ICustomer } from "types/customer"

export const getColumns = (T: any): ITableColumn[] => [
  {
    key: "customers.table.columns.customer",
    label: T("customers.table.columns.customer"),
    render: (data: ICustomer) =>
      <Flex gap={"10px"} >
        <Flex align={"center"} justifyContent="center" borderRadius={"50%"} h={"30px"} w={"30px"} bgColor="#E9F2FD" > <Icon
          name={`${data?.blocked ? "filledLock" : "user"}`}
          iconStyles={{
            width: "15px",
            height: "15px",
            fill: `${data?.blocked ? "red" : "primary"}`
          }}
        /></Flex>
        <Text fontSize={"base"}>{formatPhoneNumber(data.userName)}</Text>
      </Flex>
  },
  {
    key: "customers.table.columns.date_of_registration",
    label: T("customers.table.columns.date_of_registration"),
    render: (data: ICustomer) => (
      <Text>
        {moment(data.regDate).format("DD.MM.YYYY")}
      </Text>
    ),
  },

  {
    key: "customers.table.columns.premium",
    label: T("customers.table.columns.premium"),
    render: (data: any) => (
      <Flex alignItems="center">
        <Icon name="settings" iconStyles={{ width: "16px", height: "16px", fill: "#046CEC" }} />
        <Text ml="5px">{T("customers.table.column.details")}</Text>
      </Flex>
    ),
  }
]
